module.exports = __webpack_public_path__ + "img/search.9fb6597c.svg";